module.exports = __webpack_public_path__ + "static/cc-about-f36f4d8b81dab531e2435b901e10d3d4.jpg";